const errorRes = (error) => {
	const message = error?.response?.data?.message ?? error?.message ?? error?.toString() ?? error;

	return message;
	// const message =
	// 	(error.response && error.response.data && error.response.data.message) ||
	// 	error.message ||
	// 	error.toString() ||
	// 	error.request;

	// return message;
};

export default errorRes;
